import React from "react";

const AppVersionsComponent = (props) => <div>{props.data}</div>;

export default AppVersionsComponent;
